import {TranslateService} from '@ngx-translate/core';
import {Injectable} from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    constructor(private translate: TranslateService) {
        super();

        this.translate.onLangChange.subscribe((e: Event) => {
            this.getAndInitTranslations();
        });

        this.getAndInitTranslations();
    }

    getAndInitTranslations(): any {
        this.translate.get(['itemsPerPageLabel', 'nextPagePaginationIconLabel',
            'firstPagePaginationIconLabel', 'previousPagePaginationIconLabel','lastPagePaginationIconLabel',
            'labelOf']).subscribe((translation) => {
            this.itemsPerPageLabel = translation['itemsPerPageLabel'];
            this.firstPageLabel = translation['firstPagePaginationIconLabel'];
            this.lastPageLabel = translation['lastPagePaginationIconLabel'];
            this.nextPageLabel = translation['nextPagePaginationIconLabel'];
            this.previousPageLabel = translation['previousPagePaginationIconLabel'];
            this.changes.next();
        });
    }

    getRangeLabel = (page: number, pageSize: number, length: number) =>  {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} ${this.translate.instant('labelOf')} ${length}`;
    }
}
